// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2g-6";
export var headerCell = "_2g-2";
export var loadingStateContent = "_2g-8";
export var rowWrapper = "_2g-4";
export var stickyAggregationCell = "_2g-b";
export var stickyAggregationRow = "_2g-7";
export var stickyColumnCell = "_2g-a";
export var stickyColumnHeaderCell = "_2g-9";
export var table = "_2g-1";
export var virtualRowWrapper = "_2g-5";
export var virtualTableContainer = "_2g-0";
export var white = "_2g-3";